export const PLAN_STATUS = Object.freeze({
  PENDING: "PENDIENTE",
  IN_PROGRESS: "EN_CURSO",
  FINALIZED: "FINALIZADO",
});

export function normalizePlanStatus(status) {
  return String(status || "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");
}

export function isPlanPending(status) {
  return normalizePlanStatus(status) === PLAN_STATUS.PENDING;
}

export function isPlanInProgress(status) {
  return normalizePlanStatus(status) === PLAN_STATUS.IN_PROGRESS;
}

export function isPlanFinalized(status) {
  return normalizePlanStatus(status) === PLAN_STATUS.FINALIZED;
}

export function isPlanEditable(status) {
  return !isPlanFinalized(status);
}

export function canDeletePlanRoutes(status) {
  return !isPlanFinalized(status);
}

export function canSendPlanToDriver(status) {
  return isPlanPending(status);
}

export function canOptimizePlanRoutes(status) {
  return isPlanPending(status);
}
